import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const Store = ({ width = "16px", height = "16px" }) =>
  websiteName === "bricostore" ? (
    // Material Design "storefront" (24x24, Apache-2.0). Color via currentColor.
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
    >
      <path
        fill="currentColor"
        d="M21.9 8.89l-1.05-4.37c-.22-.9-1-1.52-1.91-1.52H5.05c-.9 0-1.69.63-1.9 1.52L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89Zm-2.99-3.9 1.05 4.37c.1.42.01.84-.25 1.17-.14.18-.44.47-.94.47-.61 0-1.14-.49-1.21-1.14L16.98 5l1.93-.01ZM13 5h1.96l.54 4.52c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31V5ZM8.49 9.52 9.04 5H11v4.69c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41-.25-.29-.37-.68-.33-1.07Zm-4.4-.16L5.09 5h1.97l-.65 5.4c-.09.65-.62 1.14-1.23 1.14-.5 0-.8-.29-.94-.47-.26-.33-.35-.75-.25-1.17ZM5 19v-6.03c.08.01.15.03.23.03.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.22-.93.58.57 1.37.93 2.24.93.85 0 1.65-.35 2.25-.95.58.59 1.37.95 2.24.95.08 0 .15-.02.23-.03V19H5Z"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      width={width}
      height={height}
    >
      <path
        fill="currentColor"
        d="m15 5.34-1-3a.5.5 0 0 0-.5-.34h-11a.5.5 0 0 0-.5.34l-1 3V8.5a.5.5 0 0 0 .5.5H2v5h1V9h3v5h8V9h.5a.5.5 0 0 0 .5-.5V5.34ZM13 13H7V9h6v4Zm1-5h-2V6h-1v2H8.5V6h-1v2H5V6H4v2H2V5.58L2.86 3h10.28L14 5.58V8Z"
      />
    </svg>
  );

export default Store;
